import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=53b07b4c&scoped=true&"
import script from "./Step.vue?vue&type=script&lang=js&"
export * from "./Step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b07b4c",
  null
  
)

export default component.exports